var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { connect } from 'react-redux';
import { feathersServices } from 'src/feathers';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import ListUserEventRoleFilter from './ListUserEventRoleFilter';
import ListUserEventRole from './ListUserEventRole';
import CardExplanation from './CardExplanation';
import Page from '../../templates/Page';
var ListUserEventRolePage = (function (_super) {
    __extends(ListUserEventRolePage, _super);
    function ListUserEventRolePage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
            users: [],
            filteredUserEventRoles: _this.props.store.userEventRoles,
        };
        _this.setFilters = _this.setFilters.bind(_this);
        _this.filterUserEventRoles = _this.filterUserEventRoles.bind(_this);
        _this.handleFindUsers = _this.handleFindUsers.bind(_this);
        _this.handlePatchUserEventRole = _this.handlePatchUserEventRole.bind(_this);
        return _this;
    }
    ListUserEventRolePage.prototype.componentDidMount = function () {
        if (this.props.store.userEventRoles &&
            this.state.users &&
            this.props.store.userEventRoles.length > this.state.users.length) {
            var users = this.props.store.userEventRoles.map(function (uER) { return uER.userId; });
            this.handleFindUsers(users);
        }
    };
    ListUserEventRolePage.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ filteredUserEventRoles: this.filterUserEventRoles(this.state, nextProps.store.userEventRoles) });
        if (!this.state.isFetching &&
            nextProps.store.userEventRoles &&
            this.state.users &&
            nextProps.store.userEventRoles.length > this.state.users.length) {
            var users = this.props.store.userEventRoles.map(function (uER) { return uER.userId; });
            this.handleFindUsers(users);
        }
    };
    ListUserEventRolePage.prototype.setFilters = function (filter) {
        var newFilter = __assign({}, this.state, filter);
        this.setState(__assign({}, newFilter, { filteredUserEventRoles: this.filterUserEventRoles(newFilter) }));
    };
    ListUserEventRolePage.prototype.filterUserEventRoles = function (filter, nextUserEventRoles) {
        var _this = this;
        var userEventRoles = (nextUserEventRoles || this.props.store.userEventRoles || []);
        userEventRoles = userEventRoles.map(function (uER) {
            if (!uER.user) {
                uER.user = _this.state.users.find(function (u) { return u.id === uER.userId; });
            }
            return uER;
        });
        if (filter.filterRole !== undefined) {
            userEventRoles = userEventRoles.filter(function (uER) { return uER.role === filter.filterRole; });
        }
        if (filter.filterString) {
            var filterString_1 = filter.filterString.toLowerCase();
            userEventRoles = userEventRoles.filter(function (uER) {
                return (uER.user.userProfile.name.toLowerCase().indexOf(filterString_1) > -1 ||
                    uER.user.userProfile.email.toLowerCase().indexOf(filterString_1) > -1);
            });
        }
        return userEventRoles.sort(function (a, b) {
            return a.role !== b.role
                ? b.role - a.role
                : a.user.userProfile.name.localeCompare(b.user.userProfile.name);
        });
    };
    ListUserEventRolePage.prototype.handleFindUsers = function (users) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (users.length === 0) {
                            return [2];
                        }
                        this.setState({ isFetching: true });
                        return [4, this.props.dispatch(feathersServices.users.find(users))];
                    case 1:
                        response = _a.sent();
                        this.setState({
                            isFetching: false,
                            users: response.value.data,
                        });
                        return [2];
                }
            });
        });
    };
    ListUserEventRolePage.prototype.handlePatchUserEventRole = function (userEventRole) {
        return this.props.dispatch(feathersServices.userEventRoles.patch(userEventRole.id, userEventRole));
    };
    ListUserEventRolePage.prototype.render = function () {
        var event = this.props.store.event;
        var documentTitle = "Manage Crew & Judges | " + event.nameShort;
        return (React.createElement(Page, { documentTitle: documentTitle, pageTitle: 'Manage Crew & Judges' },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: { span: 24, push: 0 }, md: { span: 8, push: 16 } },
                    React.createElement(CardExplanation, null)),
                React.createElement(Col, { xs: { span: 24, push: 0 }, md: { span: 16, pull: 8 } },
                    React.createElement(Card, { className: 'tableCard' },
                        React.createElement(ListUserEventRoleFilter, { setFilters: this.setFilters }),
                        React.createElement(ListUserEventRole, { users: this.state.users, userEventRoles: this.state.filteredUserEventRoles, user: this.props.store.user, handlePatchUserEventRole: this.handlePatchUserEventRole }))))));
    };
    return ListUserEventRolePage;
}(React.Component));
var mapStateToProps = function (state) { return ({
    store: {
        userEventRoles: state.workspaceEvent.userEventRoles && state.workspaceEvent.userEventRoles.data,
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
    },
}); };
export default connect(mapStateToProps)(ListUserEventRolePage);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListUserEventRolePage/index.tsx
// module id = 1039
// module chunks = 0